import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-block-anchor', {
  mixins: [eventListenerMixin],

  properties: {
    url: {
      type: String,
    },

    turbolinks: {
      type: Object,
      default: null,
    },

    stackOptions: {
      type: Object,
      default: {},
    },
  },

  connected() {
    this.listenTo(this, 'click', this.handleClick.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  handleClick(event) {
    if (closest(event.target, 'a')) return;

    if (this.turbolinks && window.Turbolinks) {
      window.Turbolinks.visit(this.url, this.turbolinks || {});
    } else if (this.stackOptions && this.stackOptions.tower_pro) {
      window.tower.showProPopover($(this), {
        feature: this.stackOptions.tower_pro,
        desc: this.stackOptions.desc,
        url: this.stackOptions.feature_url,
        center: this.stackOptions.center,
        position: this.stackOptions.position,
      });
    } else {
      window.tower.stack.load(this.url, this.stackOptions);
    }
  },
});
